import React from 'react';
import styled from 'styled-components';
import colors from '../utils/colors';
import fonts from '../utils/fonts';

import Firma from './Firma';

const Enfoqueh1 = styled.h1`
  font-size: 4rem;
  margin: 0 auto;
  margin-top: 2rem;
  margin-bottom: 2.9rem;
  color: ${colors.black};
  text-transform: uppercase;
  font-family: ${fonts.serif}, serif;
  font-weight: 100;
  letter-spacing: 0.1rem;
  @media (max-width: 768px) {
    font-size: 3rem;
  }
`;

const BreakGrande = styled.br`
  display: none;
  @media (min-width: 768px) {
    display: inline;
  }
`;

const Destacado = styled.span`
  color: ${colors.main};
  font-family: ${fonts.serif}, serif;
`;

const TituloSec = () => (
  <div>
    <Enfoqueh1>
    La tecnología es arte <BreakGrande />
      <Destacado>y la ciencia, sólo una</Destacado>
    </Enfoqueh1>
    <Firma contenido="Pilar Vera" />
  </div>
);

export default TituloSec;



// WEBPACK FOOTER //
// ./src/components/TituloSec.js